import STATIC_COUNTRIES from '../../Constants/countries.json';

export interface CountryItem {
  name: { common: string };
  flags: { svg: string };
}

// Static country data - replaces external restcountries.com API call (CORS-safe)
export const getStaticCountriesData = (): Promise<any> => {
  return Promise.resolve({
    data: STATIC_COUNTRIES,
    status: 200,
    statusText: 'OK',
    headers: {},
    config: {},
  });
};

export const getCountryNames = (arr: []) => {
  const countries: any = [];
  arr.forEach((item: any) => {
    countries.push({ id: item.name.common, name: item.name.common });
  });

  return countries;
};
